import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url: '/admin/order',
    method: 'get',
    params: params
  })
}
//盈利订单列表
export function profitList(params) {
  return request({
    url: '/admin/profit/profitOrder/list',
    method: 'get',
    params: params
  })
}
//盈利订单记录
export function profitlogList(params) {
  return request({
    url: '/admin/profit/profitOrder/log/list',
    method: 'get',
    params: params
  })
}
export function add(data) {
  return request({
    url: '/admin/order',
    method: 'post',
    data: data
  })
}

export function get(id) {
  return request({
    url: '/admin/order/' + id,
    method: 'get'
  })
}

export function edit(data) {
  return request({
    url: '/admin/order',
    method: 'put',
    data: data
  })
}

export function del(id) {
  return request({
    url: '/admin/order/' + id,
    method: 'delete'
  })
}

export function cancel(id) {
  return request({
    url: '/admin/order/close/' + id,
    method: 'put'
  })
}
export function listOrderRebateBenefitRecord(orderSn) {
  return request({
    url: '/ucenter/ucRebateBenefitRecord/listOrderRebateBenefitRecord?orderSn=' + orderSn,
    method: 'get'
  })
}
export function batchCancel(idList) {
  return request({
    url: '/admin/order/batchClose',
    method: 'post',
    data:idList
  })
}

// 查询1分钟内是否有新持仓
export function checkRecentOrder() {
  return request({
    url: '/admin/order/exists/within-one-minute',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/order.js